// this script was provided by GloveFit
import { jsx as _jsx } from "react/jsx-runtime";
const SCRIPT_CONTENT = `
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var s = document.createElement('script');
      s.defer = true;
      s.src = 'https://dhc3d5wa5sazw.cloudfront.net/c/ee64e069-53ee-11ef-89c8-0ef3cbbf7f4f.js?v=' + JSON.parse(xhr.responseText).version;
      document.head.appendChild(s);
    };
    xhr.open('GET', 'https://console.glove.fit/api/general/version', true);
    xhr.send();
  `;
const GloveScript = ()=>{
    return /*#__PURE__*/ _jsx("script", {
        dangerouslySetInnerHTML: {
            __html: SCRIPT_CONTENT
        }
    });
};
export default GloveScript;
